export { default } from './AiConfirmCard';
